/* eslint-disable camelcase */
import {List, Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import VacationBehaviorIds from 'web-app/behaviors/vacation-behavior-ids';

import * as Actions from './actions';
import {ReplyStatus} from './constants';

interface Reply {
    childId: string;
    child: {
        name: {
            fullName: string;
        };
        profileImage?: {
            small: string;
        };
    };
    group?: string;
    repliedAt_localdate: string | null;
}

interface Recipient {
    id: string;
    image: string | undefined;
    recipient: string;
    title: string;
}

export interface Day {
    day_localdate: string;
}

export interface VacationPlan {
    vacationId: string;
    institutionId: string;
    createdAt: string;
    askForDetailedAttendance: boolean;
    counts: {
        replied: number;
        notReplied: number;
    };
    body: string;
    title: string;
    recipients: List<Recipient>;
    days: List<Day>;
    deadline_localdate: string;
    period?: {
        from_localdate: string;
        to_localdate: string;
    };
}

export class VacationPlanningState extends Record<{
    readonly loading: boolean;
    readonly deleting: boolean;
    readonly vacationPlans: List<VacationPlan>;
    readonly vacationPlan?: VacationPlan & {replies: List<Reply>};
    readonly showAskForDetailedAttendance: boolean;
    readonly selectedStatusOption: ReplyStatus;
}>({
    loading: false,
    deleting: false,
    vacationPlans: List(),
    vacationPlan: undefined,
    showAskForDetailedAttendance: false,
    selectedStatusOption: ReplyStatus.All,
}) {}

export default makeReducer<VacationPlanningState>(
    [
        match(Actions.fetch, state => {
            return state.merge({
                loading: true,
            });
        }),
        match(Actions.fetchSuccess, (state, {payload}) => {
            return state.merge({
                loading: false,
                vacationPlans: List(payload.response.vacations),
                showAskForDetailedAttendance: new BehaviorsCollection(payload.response.behaviors).includes(
                    VacationBehaviorIds.ShowAskForDetailedAttendance,
                ),
            });
        }),
        match(Actions.fetchFailed, state => {
            return state.merge({
                loading: false,
            });
        }),
        match(Actions.fetchSingle, state => {
            return state.merge({
                loading: true,
                selectedStatusOption: ReplyStatus.All,
            });
        }),
        match(Actions.fetchSingleSuccess, (state, {payload}) => {
            return state.merge({
                loading: false,
                vacationPlan: {
                    ...payload.response.vacation,
                    replies: List(payload.response.allReplies),
                },
            });
        }),
        match(Actions.fetchSingleFailed, state => {
            return state.merge({
                loading: false,
            });
        }),
        match(Actions.deleteVacationPlan, state => {
            return state.merge({
                deleting: true,
            });
        }),
        match(Actions.deleteVacationPlanSuccess, state => {
            return state.merge({
                deleting: false,
            });
        }),
        match(Actions.deleteVacationPlanFailed, state => {
            return state.merge({
                deleting: false,
            });
        }),
        match(Actions.deleteVacationPlanAborted, state => {
            return state.merge({
                deleting: false,
            });
        }),
        match(Actions.selectStatusOption, (state, {payload}) => {
            return state.merge({
                selectedStatusOption: payload.status,
            });
        }),
    ],
    new VacationPlanningState(),
);
